// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1z8kB","col":"styles_col__2hc1g"};